// The twelve launch workflows offered with the trades tiers, shown as the
// wizard's Workflow step. Slugs mirror the backend's WORKFLOW_SLUGS
// (OnboardingSubmission.kt) - keep the two lists in sync. Names and blurbs
// paraphrase marketing/gtm/reference/workshop/01..12.

export type WorkflowDef = {
  slug: string;
  name: string;
  // One-line pitch shown on the card.
  blurb: string;
};

// Which tiers see the Workflow step, by tier_definition.tier_code. Unlike
// the channel map this is FAIL-CLOSED: the step only renders for tiers
// that explicitly include a launch workflow.
export const WORKFLOW_STEP_TIERS: ReadonlyArray<string> = ["tier-1", "tier-2", "tier-3"];

export const workflowStepIncludedForTier = (tier: string | null | undefined): boolean =>
  tier != null && WORKFLOW_STEP_TIERS.includes(tier);

export const WORKFLOWS: ReadonlyArray<WorkflowDef> = [
  {
    slug: "email-to-job-card",
    name: "Lead to job card",
    blurb: "Answer every inbound lead and create the job card automatically.",
  },
  {
    slug: "quoting-pricing-profitability",
    name: "Quoting & profitability",
    blurb: "Build quotes faster and see which jobs actually make money.",
  },
  {
    slug: "invoicing-payment-chasing",
    name: "Invoicing & payment chasing",
    blurb: "Send invoices the moment jobs close and chase unpaid bills.",
  },
  {
    slug: "job-scheduling-routing",
    name: "Job scheduling & routing",
    blurb: "Plan each day's jobs and routes without the whiteboard.",
  },
  {
    slug: "dashboards-sales-analytics",
    name: "Dashboards & sales analytics",
    blurb: "See your leads, sales, and job numbers at a glance.",
  },
  {
    slug: "timesheets-reporting-compliance",
    name: "Timesheets & compliance",
    blurb: "Collect timesheets and keep reporting and compliance current.",
  },
  {
    slug: "reactivation-repeat-business",
    name: "Reactivation & repeat business",
    blurb: "Win back past customers with timely follow-ups.",
  },
  {
    slug: "support-faq-inbox",
    name: "Support & FAQ inbox",
    blurb: "Answer common customer questions straight from the inbox.",
  },
  {
    slug: "ask-the-boss-inventory",
    name: "Ask-the-boss & inventory",
    blurb: "Instant answers about the business, plus simple stock tracking.",
  },
  {
    slug: "marketing-reviews",
    name: "Marketing & reviews",
    blurb: "Ask happy customers for reviews and keep marketing ticking over.",
  },
  {
    slug: "lead-qualification",
    name: "Lead qualification",
    blurb: "Sort serious inquiries from tyre-kickers before you spend time.",
  },
  {
    slug: "prioritising-work-leads",
    name: "Prioritising work & leads",
    blurb: "Rank jobs and leads so the important ones come first.",
  },
];
